var map = {
	"./Archer_L.png": 92389,
	"./Awkward.png": 97916,
	"./AwkwardAirplane_R.png": 92137,
	"./BackRollMidPoint.png": 71573,
	"./Banana_L.png": 94163,
	"./Bharadvaja_L.png": 4736,
	"./BirdOfParadiseRevolvedPreparation_L.png": 9333,
	"./BirdOfParadiseRevolved_L.png": 8794,
	"./BlissfulBaby.png": 41139,
	"./BoatBind.png": 35802,
	"./BoatBindOutsideEdge.png": 3694,
	"./BoatBindOutsideEdgeHalf.png": 14917,
	"./BoatBindOutsideEdgePreparation.png": 61347,
	"./BoatBindPreparation.png": 17847,
	"./BoatFull.png": 51744,
	"./BoatHalf.png": 43604,
	"./BoatLow.png": 3593,
	"./BoundAngle.png": 65596,
	"./BoundAngleForward.png": 98885,
	"./BoundAngleII.png": 15750,
	"./Bow.png": 27541,
	"./BowBigToeI.png": 43738,
	"./BowBigToeII.png": 49857,
	"./BowHalf_R.png": 33905,
	"./BowPreparation.png": 43102,
	"./BowSide_R.png": 91067,
	"./BoxHandToAnkle_R.png": 31918,
	"./BoxNeutral.png": 27669,
	"./BoxTwist_L.png": 38864,
	"./Bridge.png": 11382,
	"./BridgeLegUp_R.png": 94496,
	"./BridgePreparation.png": 29195,
	"./Butterfly.png": 84288,
	"./ButterflyPreparation.png": 59041,
	"./Camel.png": 79839,
	"./CamelEasy.png": 2909,
	"./CamelPreparation.png": 98732,
	"./CamelPreparationHandsOnHips.png": 27117,
	"./Cat.png": 78189,
	"./CatBalanceElbowToKnee_R.png": 74093,
	"./CatBalance_R.png": 38410,
	"./Caterpillar.png": 25336,
	"./Chair.png": 31630,
	"./ChairLookingUp.png": 9336,
	"./ChairPrayer.png": 94975,
	"./ChairSideTwist_L.png": 32723,
	"./ChairTwistBindUp_R.png": 77060,
	"./ChairTwistBind_R.png": 68215,
	"./ChairTwistExtended_R.png": 63997,
	"./ChairTwist_R.png": 35762,
	"./Child.png": 78615,
	"./ChildTraditional.png": 3572,
	"./ChildWide.png": 34602,
	"./ChildWideSideBend_R.png": 69861,
	"./ChildWideSideLean_R.png": 42812,
	"./ChinStand.png": 13885,
	"./ChinStandScorpion.png": 85826,
	"./ChinStandSingleLeg_R.png": 38858,
	"./Cobra.png": 11366,
	"./CobraFull.png": 65029,
	"./CobraKing.png": 87567,
	"./Corpse.png": 69109,
	"./CorpseConstructive.png": 17094,
	"./CorpseDoubleLegRaise.png": 71790,
	"./CorpseExtended.png": 54262,
	"./CorpseFront.png": 372,
	"./CorpseFrontArmsForward.png": 7094,
	"./CorpseFrontHandsUnderShoulders.png": 98521,
	"./CorpseFrontNeckStretch_R.png": 5289,
	"./CorpseFrontPrayer.png": 64573,
	"./CorpseNeckStretch_L.png": 55948,
	"./Cradle_L.png": 71657,
	"./Crane.png": 99098,
	"./CraneOneLegged_R.png": 64743,
	"./CrescentMoon_L.png": 38214,
	"./CrookedMonkeyForearm_L.png": 19900,
	"./CrookedMonkey_L.png": 22304,
	"./Crow.png": 19620,
	"./CrowFlying_R.png": 11666,
	"./CrowSideExtended_L.png": 85219,
	"./CrowSidePreparation_L.png": 73803,
	"./CrowSide_L.png": 28764,
	"./DeafMan.png": 94038,
	"./Dog.png": 70271,
	"./Dolphin.png": 86553,
	"./DolphinHamstring_R.png": 73327,
	"./DolphinLegUp_R.png": 57193,
	"./DolphinOnToes.png": 57157,
	"./DownwardDog.png": 49645,
	"./DownwardDogBentKnees.png": 8938,
	"./DownwardDogHamstring_R.png": 58787,
	"./DownwardDogHandToAnkle_R.png": 97631,
	"./DownwardDogKneeToForeheadKneeling_R.png": 29329,
	"./DownwardDogKneeToForehead_R.png": 78204,
	"./DownwardDogLegUpKneeling_R.png": 33880,
	"./DownwardDogLegUpStackHipsBind_R.png": 4508,
	"./DownwardDogLegUpStackHips_R.png": 58313,
	"./DownwardDogLegUp_R.png": 5293,
	"./DownwardDogOnToes.png": 80225,
	"./DownwardFish.png": 32213,
	"./Duck.png": 93550,
	"./EagleForward_L.png": 62863,
	"./Eagle_L.png": 75472,
	"./Easy.png": 4843,
	"./EasyForward.png": 2236,
	"./EasyTwist_L.png": 4975,
	"./EightAngle_L.png": 65614,
	"./EightPoint.png": 77052,
	"./ElephantTrunkPreparation_L.png": 31922,
	"./ElephantTrunk_L.png": 36599,
	"./Embryo.png": 42967,
	"./EmbryoWomb.png": 4148,
	"./EmbryoWombHandsOnCrown.png": 95022,
	"./EmbryoWombHandsOnCrownBack.png": 95539,
	"./Equestrian_R.png": 57905,
	"./FallenTriangle_R.png": 38780,
	"./FeatheredPeacock.png": 82653,
	"./FeatheredPeacockEagle_L.png": 39148,
	"./FeatheredPeacockLotus.png": 67044,
	"./FigureFourTwistExtended_R.png": 83644,
	"./FigureFourTwist_R.png": 71407,
	"./FigureFour_R.png": 88158,
	"./FireLogForward_R.png": 84551,
	"./FireLog_R.png": 95436,
	"./Firefly.png": 47802,
	"./Fish.png": 71363,
	"./FishLotus.png": 54678,
	"./FishPreparation.png": 14312,
	"./FlamingoHumble_R.png": 99832,
	"./FloatingStick.png": 74695,
	"./FlyingLizard_R.png": 57895,
	"./FlyingManRevolved_L.png": 7312,
	"./FootBehindHeadElevated_L.png": 86900,
	"./FootBehindHeadForward_L.png": 5517,
	"./FootBehindHeadTwoLegged.png": 69089,
	"./FootBehindHeadTwoLeggedElevated.png": 48895,
	"./FootBehindHead_L.png": 12318,
	"./ForwardBend.png": 56595,
	"./ForwardBendBigToe.png": 11357,
	"./ForwardBendBigToePreparation.png": 38150,
	"./ForwardBendBind.png": 34622,
	"./ForwardBendDeep.png": 3889,
	"./ForwardBendHalfWay.png": 36475,
	"./ForwardBendPreparation.png": 99864,
	"./ForwardBendTwist_L.png": 61623,
	"./FourLimbedStaff.png": 51034,
	"./Frog.png": 57639,
	"./FrogTraditional.png": 57796,
	"./FrogTraditionalPreparation.png": 43997,
	"./Garland.png": 28424,
	"./GarlandSideways_R.png": 63802,
	"./GatePreparation_L.png": 66684,
	"./GateReverse_L.png": 47109,
	"./Gate_L.png": 4181,
	"./GherandaI_R.png": 9247,
	"./GoddessArmsUp_R.png": 14725,
	"./GoddessBothHeelsRaise_R.png": 89677,
	"./GoddessCactusArms_R.png": 16383,
	"./GoddessOneHeelRaise_R.png": 12589,
	"./Goddess_R.png": 67291,
	"./Gorilla.png": 27027,
	"./GorillaPreparation.png": 38328,
	"./Grasshopper_R.png": 38454,
	"./HalfFrogTraditional_L.png": 1744,
	"./HalfMoonBoundHands_R.png": 95416,
	"./HalfMoonBound_R.png": 31494,
	"./HalfMoonRevolvedBound_R.png": 67435,
	"./HalfMoonRevolvedBow_R.png": 25051,
	"./HalfMoonRevolved_R.png": 45837,
	"./HalfMoon_R.png": 5886,
	"./Handstand.png": 15564,
	"./HandstandEagle_L.png": 97895,
	"./HandstandHalfWay.png": 87794,
	"./HandstandLotus.png": 30927,
	"./HandstandScorpion.png": 56427,
	"./HandstandScorpionOneLegged_R.png": 35888,
	"./HandstandSplits_R.png": 62556,
	"./HandstandTuck.png": 48675,
	"./HeadToKneeIIIPreparation_L.png": 19770,
	"./HeadToKneeIII_L.png": 88639,
	"./HeadToKneeIIPreparation_L.png": 25177,
	"./HeadToKneeII_L.png": 66118,
	"./HeadToKneePreparation_L.png": 81907,
	"./HeadToKneeRevolved_L.png": 66831,
	"./HeadToKnee_L.png": 53444,
	"./HeadstandSupported.png": 52713,
	"./HeadstandSupportedBoundAngle.png": 652,
	"./HeadstandSupportedEagle_L.png": 63392,
	"./HeadstandSupportedEmbryo.png": 68775,
	"./HeadstandSupportedHalfWay.png": 48493,
	"./HeadstandSupportedII.png": 1063,
	"./HeadstandSupportedIII.png": 40550,
	"./HeadstandSupportedIIIPreparation.png": 37915,
	"./HeadstandSupportedIIIPreparationHipsOverHead.png": 36705,
	"./HeadstandSupportedIIPreparation.png": 73140,
	"./HeadstandSupportedIIPreparationHipsOverHead.png": 83834,
	"./HeadstandSupportedIV.png": 37968,
	"./HeadstandSupportedIVPreparation.png": 94961,
	"./HeadstandSupportedIVPreparationHipsOverHead.png": 21687,
	"./HeadstandSupportedLift.png": 77534,
	"./HeadstandSupportedLotus.png": 79112,
	"./HeadstandSupportedLotusSide_R.png": 7870,
	"./HeadstandSupportedOneLeggedSide_R.png": 76791,
	"./HeadstandSupportedOneLegged_R.png": 46018,
	"./HeadstandSupportedPreparation.png": 94170,
	"./HeadstandSupportedPreparationHipsOverHead.png": 4720,
	"./HeadstandSupportedRevolvedSplitLeggedPreparation_R.png": 25834,
	"./HeadstandSupportedRevolvedSplitLegged_R.png": 17699,
	"./HeadstandSupportedSide_R.png": 839,
	"./HeadstandSupportedTuck.png": 13038,
	"./HeadstandTripod.png": 19739,
	"./HeadstandTripodEagle_L.png": 40486,
	"./HeadstandTripodKneesOnElbows.png": 76928,
	"./HeadstandTripodLotus.png": 52606,
	"./HeadstandTripodPreparation.png": 68928,
	"./HeadstandTripodPreparationHipsOverHead.png": 47470,
	"./HeadstandTripodPreparationWideLegged.png": 54969,
	"./HeadstandTripodSpiralLegs.png": 31867,
	"./HeadstandTripodStraightArms.png": 49544,
	"./HeadstandTripodStraightArmsII.png": 52482,
	"./HeadstandTripodStraightArmsIIPreparation.png": 49055,
	"./HeadstandTripodStraightArmsIIPreparationHipsOverHead.png": 47181,
	"./HeadstandTripodStraightArmsPreparation.png": 87657,
	"./HeadstandTripodStraightArmsPreparationHipsOverHead.png": 815,
	"./Hero.png": 2185,
	"./HeroHalfReclining_L.png": 26992,
	"./HeroHalf_L.png": 5315,
	"./HeroReclining.png": 7884,
	"./HeroRecliningExtended.png": 93587,
	"./HeroTwist_L.png": 50813,
	"./HeronPreparation_L.png": 93957,
	"./Heron_L.png": 96586,
	"./HorizonLunge_L.png": 60066,
	"./Horse_L.png": 68691,
	"./KneePileBindForward_R.png": 20909,
	"./KneePileBind_R.png": 11058,
	"./KneePileEagleForward_R.png": 3352,
	"./KneePileEagle_R.png": 52065,
	"./KneePileForward_R.png": 95262,
	"./KneePileTwist_L.png": 35626,
	"./KneePile_R.png": 85791,
	"./LiftUp.png": 36581,
	"./LiftUpPreparation.png": 81966,
	"./LittleThunderbolt.png": 87298,
	"./LizardBound_R.png": 2830,
	"./LizardKneeling_R.png": 39451,
	"./Lizard_R.png": 53814,
	"./Locust.png": 37963,
	"./LocustFull.png": 58076,
	"./LocustHalfArmForward_R.png": 62714,
	"./LocustHalf_R.png": 30435,
	"./LocustII.png": 59721,
	"./LocustIII.png": 92220,
	"./LocustPreparation.png": 95248,
	"./LordOfTheDanceFull_R.png": 31193,
	"./LordOfTheDancePreparation_R.png": 68477,
	"./LordOfTheDanceRevolved_R.png": 41889,
	"./LordOfTheDance_R.png": 29306,
	"./LordOfTheFishesHalf_L.png": 34750,
	"./LordOfTheFishes_L.png": 3697,
	"./LotusBound.png": 10214,
	"./LotusBoundForward.png": 54007,
	"./LotusElevated.png": 66838,
	"./LotusFull.png": 83683,
	"./LotusHalf.png": 76731,
	"./LotusLevitating.png": 67723,
	"./LungeArmForward_R.png": 26354,
	"./LungeArmUp_R.png": 76144,
	"./LungeBack_R.png": 22650,
	"./LungeBind_R.png": 93518,
	"./LungeCrescentCactusArms_R.png": 56682,
	"./LungeCrescentEagleBackbend_R.png": 80682,
	"./LungeCrescentEagleForward_R.png": 45697,
	"./LungeCrescentEagle_R.png": 38862,
	"./LungeCrescentForwardArmsSide_R.png": 95693,
	"./LungeCrescentForwardBend_R.png": 13972,
	"./LungeCrescentHandsOnHipsForwardBend_R.png": 38573,
	"./LungeCrescentHandsOnHips_R.png": 741,
	"./LungeCrescentKneelingBind_R.png": 91002,
	"./LungeCrescentKneelingCactusArms_R.png": 99795,
	"./LungeCrescentKneelingEagleBackbend_R.png": 48021,
	"./LungeCrescentKneelingEagleForward_R.png": 13184,
	"./LungeCrescentKneelingEagle_R.png": 2921,
	"./LungeCrescentKneelingForwardArmsSide_R.png": 23858,
	"./LungeCrescentKneelingForwardBend_R.png": 91807,
	"./LungeCrescentKneelingHandsInterlaced_R.png": 30178,
	"./LungeCrescentKneelingHandsOnHipsForwardBend_R.png": 87616,
	"./LungeCrescentKneelingHandsOnHips_R.png": 74318,
	"./LungeCrescentKneelingLookingUp_R.png": 58801,
	"./LungeCrescentKneelingTriceps_R.png": 69669,
	"./LungeCrescentKneelingTwistReverse_R.png": 37946,
	"./LungeCrescentKneelingTwist_R.png": 84012,
	"./LungeCrescentTriceps_R.png": 594,
	"./LungeCrescentTwistReverse_R.png": 99779,
	"./LungeCrescentTwist_R.png": 30147,
	"./LungeCrescent_R.png": 21906,
	"./LungeHandsOnMatBack_R.png": 84131,
	"./LungeHandsOnMatFlying_L.png": 99657,
	"./LungeHandsOnMat_R.png": 1534,
	"./LungeKneelingArmForward_R.png": 67779,
	"./LungeKneelingArmUp_R.png": 96867,
	"./LungeKneelingHandsOnMatBack_R.png": 32198,
	"./LungeKneelingHandsOnMat_R.png": 21767,
	"./LungeKneelingPrayer_R.png": 5407,
	"./LungeKneelingTwistExtendedBound_R.png": 86348,
	"./LungeKneelingTwistExtended_R.png": 41884,
	"./LungeKneelingTwist_R.png": 71055,
	"./LungeKneeling_R.png": 67198,
	"./LungePrayer_R.png": 36066,
	"./LungeShoulderUnderKnee_R.png": 58306,
	"./LungeTwistExtendedBound_R.png": 12933,
	"./LungeTwistExtended_R.png": 67807,
	"./LungeTwist_R.png": 85984,
	"./Lunge_R.png": 81563,
	"./MarichiIIITraditional_L.png": 45963,
	"./MarichiIII_L.png": 52160,
	"./MarichiIITraditionalPreparation_L.png": 29897,
	"./MarichiIITraditional_L.png": 22614,
	"./MarichiITraditionalPreparation_L.png": 22504,
	"./MarichiITraditional_L.png": 99465,
	"./MarichiIVTraditional_L.png": 9423,
	"./MarichiI_L.png": 51334,
	"./Mountain.png": 9412,
	"./MountainArmsSide.png": 85688,
	"./MountainArmsUp.png": 55382,
	"./MountainBackbend.png": 82924,
	"./MountainCactusArms.png": 17016,
	"./MountainExtended.png": 15243,
	"./MountainFeetApart.png": 59864,
	"./MountainSalute.png": 73520,
	"./MountainSideTwist_L.png": 42205,
	"./Partridge_L.png": 21220,
	"./Peacock.png": 32191,
	"./PeacockLotus.png": 94554,
	"./PeacockPreparation.png": 82732,
	"./Pendant.png": 58707,
	"./Pigeon.png": 75611,
	"./PigeonFlying_R.png": 82313,
	"./PigeonForwardBend_R.png": 24934,
	"./PigeonFull_R.png": 10871,
	"./PigeonHalf_R.png": 7539,
	"./PigeonKingFull.png": 8461,
	"./PigeonKing_R.png": 34849,
	"./Plank.png": 37261,
	"./PlankAwkward_R.png": 63091,
	"./PlankDolphin.png": 22293,
	"./PlankDolphinKneeToElbow_R.png": 52665,
	"./PlankDolphinKneeling.png": 2776,
	"./PlankDolphinSide_L.png": 95877,
	"./PlankKneeToElbow_R.png": 85697,
	"./PlankKneeToOppositeElbow_R.png": 57884,
	"./PlankKneeling.png": 6336,
	"./PlankKneelingSide_L.png": 92088,
	"./PlankLegUpKneeling_R.png": 5016,
	"./PlankLegUp_R.png": 39789,
	"./PlankSideExtended_L.png": 74390,
	"./PlankSideFallenTriangle_L.png": 99683,
	"./PlankSideHalfLotus_L.png": 66311,
	"./PlankSideShiva_L.png": 81710,
	"./PlankSideStar_L.png": 27145,
	"./PlankSideTree_L.png": 17245,
	"./PlankSide_L.png": 36269,
	"./PlankUpward.png": 98580,
	"./PlankUpwardLegUp_R.png": 95862,
	"./PlankUpwardPreparation.png": 76205,
	"./Plow.png": 37531,
	"./ProneBowHalfPreparation_L.png": 84060,
	"./ProneBowHalf_L.png": 83733,
	"./PuppyExtended.png": 24484,
	"./PuppyExtendedStraightLegs.png": 5281,
	"./PyramidArmsUpPreparation_R.png": 40955,
	"./PyramidKneeling_R.png": 92483,
	"./PyramidPrayer_R.png": 47951,
	"./PyramidPreparation_R.png": 19113,
	"./Pyramid_R.png": 9166,
	"./Rabbit.png": 82133,
	"./RagDoll.png": 41328,
	"./RelaxedStance.png": 78660,
	"./Rooster.png": 36929,
	"./RoosterUpward.png": 74768,
	"./Scale.png": 93383,
	"./ScaleForward.png": 54432,
	"./Scorpion.png": 81078,
	"./ScorpionOneLegged_R.png": 69915,
	"./Seated.png": 30861,
	"./SeatedCat.png": 35953,
	"./SeatedCow.png": 42272,
	"./SeatedForwardBend.png": 23367,
	"./SeatedForwardBendHalfLotusPreparation_L.png": 28873,
	"./SeatedForwardBendHalfLotus_L.png": 48438,
	"./SeatedForwardBendII.png": 49077,
	"./SeatedForwardBendIII.png": 84304,
	"./SeatedForwardBendIIIPreparation.png": 71217,
	"./SeatedForwardBendIIPreparation.png": 69054,
	"./SeatedForwardBendIV.png": 20290,
	"./SeatedForwardBendIVPreparation.png": 65791,
	"./SeatedForwardBendPreparation.png": 4692,
	"./SeatedForwardBendRevolved_L.png": 26601,
	"./SeatedForwardBendThreeLimbsPreparation_L.png": 28516,
	"./SeatedForwardBendThreeLimbs_L.png": 31645,
	"./SeatedForwardBendWideAngle.png": 32149,
	"./SeatedForwardBendWideAngleII.png": 95251,
	"./SeatedForwardBendWideAnglePreparation.png": 95454,
	"./SeatedGatePreparation_L.png": 75808,
	"./SeatedGate_L.png": 58081,
	"./SeatedHandToToeRevolved_R.png": 3073,
	"./SeatedOnHeelsHandsOnMat.png": 15412,
	"./SeatedOnHeelsHandsOnMatOpenedKnees.png": 13943,
	"./SeatedOnHeelsPrayer.png": 9468,
	"./SeatedOnHeelsPrayerOpenedKnees.png": 16015,
	"./SeatedOnHeelsPrayerTwist_L.png": 94306,
	"./SeatedOnHeelsTwistBound_L.png": 67043,
	"./SeatedVisvamitra_L.png": 48374,
	"./Setu.png": 40000,
	"./SetuPreparation.png": 15361,
	"./ShivaSquatPrayer_R.png": 28122,
	"./ShivaSquat_R.png": 60867,
	"./ShoulderstandLotus.png": 43600,
	"./ShoulderstandSupported.png": 45679,
	"./ShoulderstandSupportedBoundAngle.png": 75726,
	"./ShoulderstandSupportedBridge.png": 72016,
	"./ShoulderstandSupportedBridgeOneLegged_R.png": 75089,
	"./ShoulderstandSupportedEagle_L.png": 97650,
	"./ShoulderstandSupportedHalf.png": 64388,
	"./ShoulderstandSupportedOneLeggedSide_R.png": 10453,
	"./ShoulderstandSupportedOneLegged_R.png": 44620,
	"./ShoulderstandSupportedSide_R.png": 44193,
	"./ShoulderstandUnsupported.png": 8728,
	"./SideAngleExtended_R.png": 50851,
	"./SideLungeExtendedBound_R.png": 91685,
	"./SideLungeExtended_R.png": 82015,
	"./SideLunge_R.png": 56960,
	"./Snake.png": 67057,
	"./Sphinx.png": 41719,
	"./SphinxNeckStretch_L.png": 35694,
	"./SplitsFrontArmsUp_R.png": 69960,
	"./SplitsFrontBind_R.png": 4919,
	"./SplitsFrontForward_R.png": 5869,
	"./SplitsFront_R.png": 48050,
	"./SplitsStandingBentKnee_R.png": 57605,
	"./SplitsStandingBound_R.png": 71823,
	"./SplitsStanding_R.png": 48441,
	"./SplitsWide.png": 27403,
	"./Staff.png": 79623,
	"./StaffInverted.png": 96328,
	"./StaffInvertedLegUp_R.png": 22458,
	"./StaffInvertedPreparation.png": 23785,
	"./StandingFootBehindHead_L.png": 77414,
	"./StandingForwardBendFootBehindHead_L.png": 59192,
	"./StandingForwardBendHalfLotusPreparation_L.png": 35245,
	"./StandingForwardBendHalfLotus_L.png": 29202,
	"./StandingHalfLotusBound_L.png": 40244,
	"./StandingHalfLotus_L.png": 71156,
	"./StandingHandToToeExtended_R.png": 42857,
	"./StandingHandToToeFull_R.png": 61525,
	"./StandingHandToToeHandsOnHips_R.png": 9297,
	"./StandingHandToToeRevolved_R.png": 22357,
	"./StandingHandToToe_R.png": 88678,
	"./StandingHeadToKneePreparationStraightBack_R.png": 97258,
	"./StandingHeadToKneePreparation_R.png": 96453,
	"./StandingHeadToKnee_R.png": 13570,
	"./StandingKneeToChest_R.png": 75467,
	"./StandingMarichi_R.png": 62151,
	"./StarArmsUp_R.png": 9776,
	"./StarHandsInterlaced_R.png": 14841,
	"./StarHandsOnHips_R.png": 62541,
	"./StarReversePrayer_R.png": 52989,
	"./StarWideStanceArmsUp_R.png": 66405,
	"./StarWideStance_R.png": 39035,
	"./Star_R.png": 98090,
	"./SuperSoldier_R.png": 19023,
	"./SupineAngle.png": 73986,
	"./SupineBellyTwistPreparation.png": 77531,
	"./SupineBellyTwist_R.png": 30025,
	"./SupineBoundAngle.png": 52834,
	"./SupineBoundAngleExtended.png": 11029,
	"./SupineFootBehindHead_L.png": 86464,
	"./SupineHandToToeExtended_R.png": 76319,
	"./SupineHandToToeFull_R.png": 85147,
	"./SupineHandToToeRevolved_R.png": 96647,
	"./SupineHandToToe_R.png": 76960,
	"./SupinePigeon_R.png": 10162,
	"./SupineSpinalTwist_R.png": 66052,
	"./SupineStraddle.png": 58620,
	"./SupineThunderbolt.png": 63652,
	"./SupineTortoise.png": 80630,
	"./SupineTortoiseBind.png": 70699,
	"./SupineTrivikrama_R.png": 30946,
	"./Table.png": 8317,
	"./TableKneeToForehead_R.png": 22764,
	"./TableLegUp_R.png": 52029,
	"./TablePreparation.png": 90214,
	"./Thunderbolt.png": 2430,
	"./ThunderboltTwist_L.png": 85292,
	"./Tiger_R.png": 35523,
	"./ToeSquat.png": 38287,
	"./ToeStandPreparation_R.png": 88861,
	"./ToeStandSupported_R.png": 27816,
	"./ToeStand_R.png": 21210,
	"./Tortoise.png": 33260,
	"./TortoiseBind.png": 53969,
	"./TortoiseBindII.png": 6767,
	"./TreePrayer_L.png": 45625,
	"./TreeSideBend_L.png": 58060,
	"./TreeToppling_R.png": 80145,
	"./Tree_L.png": 86347,
	"./TriangleBound_R.png": 50794,
	"./TriangleForward_R.png": 20549,
	"./TriangleReverse_R.png": 39588,
	"./TriangleRevolved_R.png": 63505,
	"./Triangle_R.png": 9930,
	"./TrivikramaI_R.png": 65121,
	"./Turtle.png": 59095,
	"./TurtleHeadTucked.png": 73545,
	"./UpwardDog.png": 98748,
	"./UpwardDogLookingUp.png": 4958,
	"./UpwardDogNeckStretch_L.png": 43199,
	"./VisvamitraFull_R.png": 35767,
	"./VisvamitraKneeling_R.png": 35217,
	"./Visvamitra_R.png": 78748,
	"./WarriorHumblePreparation_R.png": 39028,
	"./WarriorHumble_R.png": 9313,
	"./WarriorICactusArms_R.png": 69901,
	"./WarriorIEagleBackbend_R.png": 56463,
	"./WarriorIEagleForward_R.png": 38358,
	"./WarriorIEagle_R.png": 76183,
	"./WarriorIForward_R.png": 48724,
	"./WarriorIHandsOnHipsForward_R.png": 67535,
	"./WarriorIHandsOnHips_R.png": 54772,
	"./WarriorIIForwardArmForward_R.png": 43204,
	"./WarriorIIForward_R.png": 86069,
	"./WarriorIIIAirplane_R.png": 6337,
	"./WarriorIIIEagle_R.png": 60241,
	"./WarriorIIIPrayer_R.png": 17038,
	"./WarriorIII_R.png": 79983,
	"./WarriorIIReverse_R.png": 6836,
	"./WarriorII_R.png": 33466,
	"./WarriorIKneeling_R.png": 25808,
	"./WarriorILookingUp_R.png": 28807,
	"./WarriorI_R.png": 33845,
	"./WarriorPrayer_R.png": 2669,
	"./WarriorTwistExtendedBound_R.png": 53706,
	"./WarriorTwistExtended_R.png": 22026,
	"./WarriorTwist_R.png": 71065,
	"./Wheel.png": 10452,
	"./WheelHeadDown.png": 15670,
	"./WheelLegUp_R.png": 80822,
	"./WheelPreparation.png": 33613,
	"./WideLeggedForwardBendHalfWay_R.png": 26229,
	"./WideLeggedForwardBendIII_R.png": 48510,
	"./WideLeggedForwardBendII_R.png": 9265,
	"./WideLeggedForwardBendIVPreparation_R.png": 36837,
	"./WideLeggedForwardBendIV_R.png": 46722,
	"./WideLeggedForwardBendI_R.png": 8408,
	"./WideLeggedForwardBendReversePrayer_R.png": 18550,
	"./WideLeggedForwardBendRevolved_R.png": 75440,
	"./WideLeggedForwardBendSide_R.png": 80002,
	"./WideLeggedForwardBendTwist_R.png": 79988,
	"./WildThingForearm_L.png": 69784,
	"./WildThing_L.png": 97239,
	"./WindRemovingHalfHeadTucked_R.png": 60264,
	"./WindRemovingHalf_R.png": 57566,
	"./YogicSleep.png": 47189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93424;